import type { TextHighlightShape as TextHighlightShapeType } from '@/features/comment-on-file';

interface Props {
  shape: TextHighlightShapeType;
  color: string;
  focused?: boolean;
}

const FILL_OPACITY_BASE = 0.35;
const FILL_OPACITY_FOCUSED = 0.55;

export function TextHighlightShape({ shape, color, focused }: Props) {
  const opacity = focused ? FILL_OPACITY_FOCUSED : FILL_OPACITY_BASE;
  return (
    <g>
      {shape.rects.map((r, i) => (
        <rect
          key={i}
          x={r.x}
          y={r.y}
          width={r.w}
          height={r.h}
          fill={color}
          fillOpacity={opacity}
          stroke="none"
        />
      ))}
    </g>
  );
}
